import axios from 'axios'
import { removeCompletedBookingInfo } from '../../utils/setLocalStorage'

export default {
  namespaced: true,
  state: {
    gettingLead: false,
    paymentAttemptError: false,
    demanderReservationError: false,
  },
  mutations: {
    SET_GETTING_LEAD(state, bool) {
      state.gettingLead = bool
    },
    SET_PAYMENT_ATTEMPT_ERROR(state, bool) {
      state.paymentAttemptError = bool
    },
    SET_DEMANDER_RESERVATION_ERROR(state, bool) {
      state.demanderReservationError = bool
    },
    SET_FIELD_ERROR(state, fieldError) {
      state.fieldError = fieldError
    },
  },
  actions: {
    POST_LEAD({ commit, rootState, rootGetters }, {
      isAgency, message, rentalType, degradedForm = null,
    }) {
      let leadType = isAgency ? 'agency' : 'online'
      if (degradedForm !== null) leadType = 'contact-reservation'

      commit('SET_GETTING_LEAD', true)
      axios.post(`${rootState.api}/leads/${leadType}`, {
        ...rootGetters['quotation/quotationFormData'],
        message,
        rental_type: rentalType,
        request_type: 5,
        renault_campaign: window.renaultRent?.sessions?.campaign,
        renault_context: window.renaultRent?.sessions?.context,
        renault_origin: window.renaultRent?.sessions?.origin,
        ...degradedForm,
      })
        .then((res) => {
          const online = leadType === 'online'
          if (!online && res.status === 201) {
            commit('stepping/TRIGGER_STEP_NAVIGATION', { step: 4, data: { leadId: res.data.lead.id } }, { root: true })
          }
          if (leadType === 'contact-reservation' && res.status === 201) {
            removeCompletedBookingInfo()
            window.location.href = '/';
          }
          if (!online) {
            return
          }
          /* eslint-disable-next-line camelcase */
          const paymentUrl = res?.data?.data?.payment_url

          window.location = paymentUrl
        })
        .catch((error) => {
          if (
            'operation' in error.response.data
            && error.response.data.operation === 'demanderReservation'
          ) {
            commit('SET_DEMANDER_RESERVATION_ERROR', true)

            if (
              error.response.data.ws_error.libelle.includes('Missing required parameters [')
              || error.response.data.ws_error.libelle.includes('format')
            ) {
              const fieldError = error.response.data.ws_error.libelle
                .replace('Missing required parameters [', '')
                .replace(']', '')
                .replace('format ', '')
                .replace(' non valide', '')
                .replace(/[A-Z]/g, (letter) => ` ${letter.toLowerCase()}`)

              commit('SET_FIELD_ERROR', fieldError)
            }
          }

          commit('SET_PAYMENT_ATTEMPT_ERROR', true)
        })
        .finally(() => commit('SET_GETTING_LEAD', false))
    },
    POST_DEGRADED_LEAD({ dispatch }, { message, rentalType, degradedForm }) {
      dispatch('POST_LEAD', {
        message, rentalType, isAgency: true, degradedForm,
      })
    },
    POST_AGENCY_LEAD({ dispatch }, { message, rentalType }) {
      dispatch('POST_LEAD', { message, rentalType, isAgency: true })
    },
    POST_ONLINE_LEAD({ dispatch }, { message, rentalType }) {
      dispatch('POST_LEAD', { message, rentalType, isAgency: false })
    },
    CLEAR_COMPLETED_BOOKING_INFO() {
      removeCompletedBookingInfo()
    },
  },

}
